import { buildModelManager } from "../builder.js";
const DefaultPhiCleanupApprovalSelection = {
  __typename: true,
  id: true,
  approvedAt: true,
  approvedById: true,
  createdAt: true,
  dryRunReport: true,
  expiresAt: true,
  institution: true,
  requestedById: true,
  scope: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "phiCleanupApproval";
const pluralModelApiIdentifier = "phiCleanupApprovals";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPhiCleanupApprovalSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPhiCleanupApprovalSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiCleanupApprovalSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiCleanupApprovalSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPhiCleanupApprovalSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPhiCleanupApprovalSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPhiCleanupApprovalSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "phiCleanupApprovalGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PhiCleanupApprovalManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPhiCleanupApprovalSelection,
  operations
);
export {
  DefaultPhiCleanupApprovalSelection,
  PhiCleanupApprovalManager
};
//# sourceMappingURL=PhiCleanupApproval.js.map
